import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { EASE } from "./constants";

const STEPS = [
  { n: "01", title: "Incontro", body: "Ci racconti la tua casa e i tuoi obiettivi. Sopralluogo e valutazione gratuita, senza impegno." },
  { n: "02", title: "Strategia", body: "Definiamo prezzo, servizio fotografico e piano di promozione mirato per il tuo immobile." },
  { n: "03", title: "Vendita", body: "Selezioniamo gli acquirenti, gestiamo trattativa e pratiche fino alla firma dal notaio." },
];

export const Process = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-15%" });

  return (
    <section id="metodo" ref={ref} data-testid="process-section" className="py-24 md:py-36 max-w-[1500px] mx-auto px-6 md:px-12 lg:px-16">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
        <div>
          <div className="overline text-[#21463E] mb-6 flex items-center gap-3">
            <span className="h-px w-8 bg-[#21463E] inline-block" /> Il Metodo
          </div>
          <h2 className="font-serif font-light text-[#2E3131] text-4xl sm:text-5xl lg:text-6xl leading-[1.03] tracking-tight max-w-2xl">
            Tre passi, dalla prima chiacchierata al rogito.
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.n}
            initial={{ opacity: 0, y: 40 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: i * 0.18, ease: EASE }}
            className="group px-0 md:px-10 py-10 md:py-4 border-b md:border-b-0 md:border-l border-[#DBDBDA] first:md:border-l-0 first:md:pl-0"
          >
            <span className="font-mono text-sm text-[#21463E]">{s.n}</span>
            <h3 className="font-serif text-3xl md:text-4xl text-[#2E3131] mt-6 mb-4 group-hover:text-[#21463E] transition-colors duration-300">{s.title}</h3>
            <p className="text-[#5C6360] leading-relaxed max-w-xs">{s.body}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Process;
